// extracted by mini-css-extract-plugin
export default {"companyContainer":"ZO-z","companyImage":"_O-z","container":"aP-z","heading":"bP-z","darkText":"cP-z","smallHeading":"dP-z","darkBackground":"eP-z","whiteBackground":"fP-z"};